module.exports = __webpack_public_path__ + "media/images/athletes/4345-3980a12ccc5d4ca6690d09a895ccf8e9.png";